import React from "react";
import { useNavigate } from "react-router-dom";

export default function GuidePage() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center w-full">

      {/* Back button */}
      <div className="w-full max-w-6xl px-4 pt-3">
        <button
          onClick={() => navigate(-1)}
          className="bg-blue-500 text-white px-3 py-1 rounded-md hover:bg-blue-600 text-sm"
        >
          ← Volver
        </button>
      </div>

      {/* Title smaller */}
      <h1 className="text-lg font-semibold mt-2 mb-3 text-center w-full px-4">
        Guía rápida Realty Shot
      </h1>

      {/* FULL WIDTH + MUCH TALLER PDF */}
      <iframe
        src="https://drive.google.com/file/d/1HSwFHTJU_S_ULFEp8f3sRNvDUGZ2OyN8/preview"
        title="Guía rápida Realty Shot"
        className="
          w-full 
          h-[85vh]          /* much taller on mobile */
          md:h-[92vh]       /* super tall on desktop */
          border 
          rounded-lg 
        "
        style={{
          margin: 0,
          padding: 0,
          overflow: "hidden",
        }}
        allow="autoplay"
      ></iframe>
    </div>
  );
}
